<div class="brand-name" [ngClass]="customClass" [title]="name">
    @if (name){
        <img [src]="logoPath" alt="" class="table-logo" (error)="onImageError($event)">    
        <span>{{ name }}</span>
    }
</div>
